<template>
  <v-container>
    <v-card>
      <v-card-title>
        メンテナンス中
      </v-card-title>
      <v-card-text>
        現在、システムメンテナンスを実施しております。<br />
        ご不便をおかけしますが、しばらくお待ちください。
      </v-card-text>

      <v-card-text>
        メンテナンス完了までしばらくお待ちください。
      </v-card-text>
      <v-card-actions>
        <v-btn
          color="primary"
          large
          @click="goHome"
        >
          ホームに戻る
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import themeConfig from '@themeConfig'

export default {
  name: 'Maintenance',
  data() {
    return {
      appLogoTypography: themeConfig.app.logoTypography,
    }
  },
  methods: {
    goHome() {
      this.$router.push('/')
    },
  },
}
</script>
